import { render, staticRenderFns } from "./TransportirLogo.vue?vue&type=template&id=7632a8e9&scoped=true&"
import script from "./TransportirLogo.vue?vue&type=script&lang=js&"
export * from "./TransportirLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7632a8e9",
  null
  
)

export default component.exports